var React = require('react');

function StarSelected (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.562 24.398C23.7639 25.2628 22.8407 25.946 22.0957 25.4832L16.4519 21.9767L10.8081 25.4832C10.0631 25.946 9.13987 25.2628 9.34181 24.398L10.8716 17.8468L5.85373 13.4628C5.19137 12.8841 5.54399 11.7786 6.41379 11.707L13.0031 11.1646L15.5457 4.94864C15.8813 4.12812 17.0225 4.12812 17.3581 4.94864L19.9007 11.1646L26.49 11.707C27.3598 11.7786 27.7124 12.8841 27.0501 13.4628L22.0322 17.8468L23.562 24.398Z","fill":"#FFB800"}));
}

StarSelected.defaultProps = {"width":"32","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = StarSelected;

StarSelected.default = StarSelected;
